import { CustomerLogoComponent } from "@shared/components/customer-logo/customer-logo.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { TooltipModule } from "@shared/components/tooltip/tooltip.module";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";

import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";
import { InputAutocompleteModule } from "@shared/components/input-autocomplete/input-autocomplete.module";
import { ModalWrapperModule } from "@shared/components/modal-wrapper/modal-wrapper.module";
import { PaygroupStatusHistoryModule } from "@shared/components/paygroup-status-history/paygroup-status-history.module";
import { SharedModule } from "@shared/shared.module";
import { ContactsModule } from "@shared/components/contacts/contacts.module";
import { CustomerLegalEntitySelectModule } from "@shared/components/customer-legal-entity-select/customer-legal-entity-select.module";
import { CustomerListModule } from "@shared/components/customer-list/customer-list.module";
import { ExpansionPanelModule } from "@shared/components/expansion-panel/expansion-panel.module";
import { FloatingActionButtonModule } from "@shared/components/floating-action-button/floating-action-button.module";
import { InputSelectModule } from "@shared/components/input-select/input-select.module";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { NoItemsLayoutModule } from "@shared/components/no-items-layout/no-items-layout.module";
import { PaginationModule } from "@shared/components/pagination/pagination.module";
import { PipesModule } from "@shared/pipes/pipes.module";
import { PayGroupListFiltersComponent } from "./_components/pay-group-list/pay-group-list-filters/pay-group-list-filters.component";
import { PayGroupListItemComponent } from "./_components/pay-group-list/pay-group-list-item/pay-group-list-item.component";
import { PayGroupListComponent } from "./_components/pay-group-list/pay-group-list.component";
import { PayGroupComponent } from "./_components/pay-group/pay-group.component";
import { PayGroupsRoutingModule } from "./pay-groups-routing.module";
import { PayGroupsComponent } from "./pay-groups.component";
import { PaygroupsReportDialogComponent } from "./_components/paygroups-report-dialog/paygroups-report-dialog.component";
import { WpayAutoCompleteModule } from "@shared/components/wpay-ui/base-components/wpay-auto-complete/wpay-auto-complete.module";

@NgModule({
	declarations: [
		PayGroupsComponent,
		PayGroupListComponent,
		PayGroupComponent,
		PayGroupListFiltersComponent,
		PayGroupListItemComponent,
		PaygroupsReportDialogComponent
	],
	imports: [
		CommonModule,
		CustomerLogoComponent,
		MatIconModule,
		MatButtonModule,
		InputWrapperModule,
		MatInputModule,
		MatFormFieldModule,
		MatMenuModule,
		FlexLayoutModule,
		PaginationModule,
		FormsModule,
		ReactiveFormsModule,
		CustomerListModule,
		InputSelectModule,
		MatCardModule,
		MatListModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		PipesModule,
		PaginationModule,
		CustomerLegalEntitySelectModule,
		NoItemsLayoutModule,
		MatDatepickerModule,
		FloatingActionButtonModule,
		ExpansionPanelModule,
		InputAutocompleteModule,
		MatPaginatorModule,
		ContactsModule,
		MatRadioModule,
		ModalWrapperModule,
		SharedModule,
		MatSlideToggleModule,
		PaygroupStatusHistoryModule,
		PayGroupsRoutingModule,
		BreadcrumbsModule,
		MatTooltipModule,
		TooltipModule,
		MatDialogModule,
		MatSelectModule,
		WpayAutoCompleteModule
	]
})
export class PayGroupsModule {}
